import Styles from './index.module.scss';
import { gotoArticleByProduct } from '@/utils/document/article-and-product';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
export interface ITopDoc {
  title: string;
  docsKey: string;
}

export interface IProduct {
  id: number;
  productCode: string;
  productName: string;
  topDocs: ITopDoc[];
}

export interface IProductType {
  productType: string;
  productList: IProduct[];
}

interface IProps {
  data: IProductType;
}

const articleUrl = 'article';

const ProductArticleEntry = (props: { product: IProduct }) => {
  const { product } = props;

  const href = `${publicRuntimeConfig.articleBaseUrl}/${encodeURIComponent(
    product.productCode
  )}${product?.topDocs?.[0] ? '/' + product?.topDocs?.[0]?.docsKey : ''}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      // remove a link style
      style={{
        color: 'inherit',
        textDecoration: 'inherit',
      }}
    >
      <span className={Styles.product}>{product.productName}</span>
    </a>
  );
};

// 布局一：产品分类纵向布局
const ProductGuidelineCardVertical = ({ data }: IProps) => {
  return (
    <div className={Styles.verticalGuideline}>
      <div id={data.productType} className={Styles.verticalLabel}>
        {data.productType}
      </div>
      <div className={Styles.productContainer}>
        {data.productList?.map((product) => (
          <ProductArticleEntry product={product} key={product.id} />
        )) || <>文档建设中，敬请期待...</>}
      </div>
    </div>
  );
};

// 布局一：产品分类横向布局
const ProductGuidelineCardHorizontal = ({ data }: IProps) => {
  return (
    <div className={Styles.horizontalGuideline}>
      <div id={data.productType} className={Styles.horizontalLabel}>
        {data.productType}
      </div>
      <div className={Styles.productContainer}>
        {data.productList?.map((product) => (
          <ProductArticleEntry product={product} key={product.id} />
        )) || <div>文档建设中，敬请期待</div>}
      </div>
    </div>
  );
};
export { ProductGuidelineCardHorizontal, ProductGuidelineCardVertical };
